var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMaintenanceVehicle = function SvgMaintenanceVehicle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1768 15.0918V17.2109C45.5856 18.1287 45.7159 19.0376 45.7159 19.7686V29.5771C46.0966 29.9619 46.4 30.5092 46.1505 31.1553L45.7159 30.9844V61.0078L26.2921 61.0254V59.9873C26.2921 57.0943 26.2781 48.3499 26.2647 39.6816C26.2601 36.6967 26.257 33.7208 26.253 30.9961L25.8468 31.1553C25.6039 30.5264 25.8849 29.9912 26.2511 29.6084C26.2445 25.0549 26.2384 21.3797 26.2384 19.8398C26.2384 18.8866 26.4337 18.039 26.7774 17.293L26.7813 15.1475L31.9376 11.9873H40.2765L45.1768 15.0918Z",
    stroke: "#BDBDBD",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6619 21.1572H26.7852V28.5656H27.6619V21.1572Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6619 44.0278H26.7852V51.4364H27.6619V44.0278Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.187 21.1572H44.3105V28.5656H45.187V21.1572Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.187 44.0278H44.3105V51.4364H45.187V44.0278Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7773 18.794H45.1789V15.0923L40.2784 11.9873H31.9399L26.7831 15.1471L26.7773 18.794Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6804 59.9715C44.6804 54.1659 44.6804 20.5908 44.6804 19.7688C44.6804 18.4734 44.2156 16.535 42.0361 15.2485C39.856 13.9619 37.2294 13.9619 35.9786 13.9619C33.7357 13.9619 31.507 14.4172 29.8667 15.4184C28.3057 16.3716 27.2773 17.8193 27.2773 19.8403C27.2773 25.0043 27.3308 54.1998 27.3308 59.9875L44.6804 59.9715Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.07454
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2012 26.1557C30.673 25.7403 33.6922 25.4009 35.8056 25.4009C37.919 25.4009 41.1272 25.5895 42.7122 26.0802C42.7122 26.0802 41.8702 30.7741 41.8071 31.1539C41.7676 31.3897 41.7455 31.5892 41.1904 31.508C40.6525 31.4294 37.5419 31.3261 36.0322 31.3261C34.5225 31.3261 31.5034 31.477 31.0504 31.5149C30.5974 31.5527 30.2956 31.6656 30.22 31.3261C30.1448 30.9865 29.2012 26.1557 29.2012 26.1557Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3047 44.3091H44.6924",
    stroke: "black",
    strokeWidth: 1.65963
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5159 17.2945L39.8418 14.3403",
    stroke: "black",
    strokeWidth: 0.452882
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5898 17.2945L32.2638 14.3403",
    stroke: "black",
    strokeWidth: 0.452882
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9582 24.9981L39.0137 15.438",
    stroke: "black",
    strokeWidth: 1.03727
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1016 24.9981L33.0458 15.438",
    stroke: "black",
    strokeWidth: 1.03727
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4707 43.2719V18.9194",
    stroke: "#E3F906",
    strokeWidth: 0.597276
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5156 43.2007V18.9194",
    stroke: "#E3F906",
    strokeWidth: 0.596422
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2051 29.9993L46.1526 31.1551C46.5495 30.1275 45.5461 29.3513 45.0612 29.0783C44.5751 28.8052 43.251 28.1055 43.251 28.1055L43.2051 29.9993Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7915 30.0054L25.8487 31.1551C25.4518 30.1275 26.4548 29.3513 26.94 29.0783C27.4259 28.8052 28.7422 28.1055 28.7422 28.1055L28.7915 30.0054Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.064 46.1505C37.0313 46.1505 37.8155 45.3663 37.8155 44.399C37.8155 43.4316 37.0313 42.6475 36.064 42.6475C35.0967 42.6475 34.3125 43.4316 34.3125 44.399C34.3125 45.3663 35.0967 46.1505 36.064 46.1505Z",
    fill: "#E3F906",
    stroke: "black",
    strokeWidth: 1.03727
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2527 28.1055C42.9506 28.9861 42.1958 31.2506 42.0702 32.6092C41.9444 33.9678 41.9695 35.729 41.9695 36.8111C41.9695 37.8929 41.894 41.0127 41.9192 41.4152C41.9444 41.8177 41.9444 42.1699 42.0703 42.4217C42.1959 42.6733 42.5483 43.1511 42.5483 43.1511C42.5483 43.1511 42.6741 43.3526 42.8504 43.0254C43.0264 42.6983 43.2276 41.7927 43.2276 41.2642C43.2275 40.7357 43.2527 28.1055 43.2527 28.1055Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7422 28.1055C29.044 28.9861 29.7988 31.2506 29.9246 32.6092C30.0505 33.9678 30.0253 35.729 30.0253 36.8111C30.0253 37.8929 30.1008 41.0127 30.0754 41.4152C30.0504 41.8177 30.0504 42.1699 29.9245 42.4217C29.7988 42.6733 29.4463 43.1511 29.4463 43.1511C29.4463 43.1511 29.3205 43.3526 29.1445 43.0254C28.9687 42.6983 28.767 41.7927 28.767 41.2642C28.7672 40.7357 28.7422 28.1055 28.7422 28.1055Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1669 46.5259H27.9277V59.69H34.1669V46.5259Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3603 46.5259H38.1211V59.69H44.3603V46.5259Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMaintenanceVehicle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "maintenance-vehicle.376f4946278329d35d86386af111ef20.svg";